export default __webpack_public_path__ + "static/media/standard.6edcff85.png";